import { Typography } from "@mui/material";
import { Box } from "@mui/system";
import React from "react";

export default function ExactCircleLayout() {
    
    return (
        <div className="circle-layout">
         <style>
{`
.circle-layout {
  --n: 4;
  --i: var(--wide, 1);
  --j: calc(1 - var(--i));
  --k: calc(1 - var(--narr, 1));
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  background: #000;
  font: 400 1em/1.25 coda, trebuchet ms, arial, sans-serif;
}

.circle-layout * {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

@media (max-width: 43em) {
  .circle-layout { --wide: 0 }
}

@media (min-width: 270px) {
  .circle-layout { --narr: 0 }
}

.circle-layout p {
  --p: var(--parity, 1);
  --q: calc(1 - var(--p));
  --s: calc(1 - 2*var(--p));

  display: flex;
  flex-direction: var(--narr, column);
  align-items: center;
  justify-content: center;


  margin: calc(var(--j)*.25em) 0;
  padding: calc(var(--i)*7em/var(--n) + var(--j)*4vw)
           calc(var(--i)*8em + var(--j)*2vw);

  width: calc(var(--i)*40em + var(--j)*100%);
  min-height: var(--wide, calc(40em/var(--n)));

  transform: translate(calc(var(--i)*var(--s)*-1.5em));

  background:
    radial-gradient(at calc(var(--q)*100%) 0,
    rgba(0,0,0,calc(.5 + var(--p)*.5)), transparent 63%)
    calc(var(--q)*100%) 0/65% 65% no-repeat,
    linear-gradient(calc(var(--s)*-90deg),
    hsl(23, calc(var(--q)*98%), calc(27% + var(--q)*20%)),
    hsl(44, calc(var(--q)*92%), 52%));

  color: HSL(0,0%,calc(var(--p)*100%));
 text-align: center;
  clip-path: var(--wide,
    circle(20em at 50%
    calc((.5*var(--n) - var(--idx))*40em/var(--n))));
}

/* 🔥 REPLACED NUMBER COUNTER WITH TEXT */
.circle-layout p::before {
  content: var(--label);
  margin: 0 calc(var(--k)*var(--q)*.25em)
          0 calc(var(--k)*var(--p)*.25em);
  order: calc(var(--k)*var(--p));
  font-size: 3.0em;
  font-weight: 700;
  white-space: nowrap;
}

.circle-layout p:nth-child(odd) {
  --parity: 0;
}
  .circle-layout p:nth-of-type(2),
.circle-layout p:nth-of-type(4) {
  background:
    radial-gradient(at 0% 0,
    rgba(0,0,0,.6), transparent 63%)
    0% 0/65% 65% no-repeat,
    linear-gradient(-90deg, #0f63a5, #0f63a5);

  color: #fff;
}
`}
</style>

            <Box sx={{ mb: 4 }}>
                <Typography
                    variant="h3"
                    component="span"
                    sx={{
                        color: "#fff",
                        fontSize: { xs: '30px', md: "35px" },
                        fontWeight: 700,
                        letterSpacing: 2,
                        mr: 1,
                    }}
                >
                    Don't Join 
                </Typography>

                <Typography
                    variant="h1"
                    sx={{
                        background:
                            "linear-gradient(90deg, #ffffff 0%, #d4af37 100%)",
                        WebkitBackgroundClip: "text",
                        WebkitTextFillColor: "transparent",
                        position: "relative",
                        display: "inline-block",
                        fontWeight: 700,
                        fontSize: { xs: "50px", md: "auto" },
                        "&::after": {
                            content: '""',
                            position: "absolute",
                            bottom: "0px",
                            left: 0,
                            width: "100%",
                            height: "10px",
                            background: "rgb(177 177 177 / 50%)",
                            borderRadius: "4px",
                        },
                    }}
                >
                     IF
                </Typography>
            </Box>
            <Box 
            sx={{
                display:'flex',
                flexDirection:'column',
                justifyContent:'center',
                alignItems:'center',
               
            }}>

                <p style={{  ["--idx" as any]: 0,marginTop:30}} >
                  <Typography variant="h6" sx={{}}>

                    You believe more leads automatically solve sales problems
                  </Typography>
                </p>
                <p style={{ ["--idx" as any]: 1 }}>
                  <Typography variant="h6" sx={{color:'white'}}>

                    You think sales inconsistency is just “market conditions”
                  </Typography>
                </p>
                <p style={{ ["--idx" as any]: 2 }}>
                  <Typography variant="h6">

                    You expect motivation instead of practical frameworks
                  </Typography>
                </p>
                <p style={{ ["--idx" as any]: 3 }}>
                  <Typography variant="h6" sx={{color:'white'}}>

                    You believe sales success depends on luck, not structured systems
                  </Typography>
                </p>
            </Box>

        </div>
    );
}